import script from "./SideBarGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarGroup.vue?vue&type=script&setup=true&lang=js"

import "./SideBarGroup.vue?vue&type=style&index=0&id=0fa8e650&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa8e650"]])

export default __exports__